export default "__VITE_ASSET__D5Fw8DFl__"